module.exports = __webpack_public_path__ + "static/media/user-info-medal.f2f4cfad.svg";